import Button from '../../../components/Button/Button';
import DialogModal from '../../../components/DialogModal/DialogModal';
import Inline from '../../../components/Inline/Inline';
import Paragraph from '../../../components/Paragraph/Paragraph';
import Row from '../../../components/Row/Row';
import SVG from '../../../components/SVG/SVG';
import Stack from '../../../components/Stack/Stack';
import Title from '../../../components/Title/Title';
import useTrans from '../../../hooks/ui/useTrans';

import icon from './graphics/icon.svg?raw';

import styles from './WaitingForLoginModal.module.css';

type WaitingForLoginModalProps = {
    onClose: () => void;
};

const WaitingForLoginModal = ({ onClose }: WaitingForLoginModalProps) => {
    const trans = useTrans('CustomerArea.Shared.WaitingForLoginModal.');

    return (
        <DialogModal
            onCloseRequested={onClose}
            width="small"
            hideCloseButton
            isOpen
        >
            <Stack space="large">
                <Title>{trans('Title')}</Title>
                <Row horizontal="center">
                    <SVG src={icon} className={styles.Icon} />
                </Row>
                <Paragraph>{trans('Instructions')}</Paragraph>
                <Inline horizontal="right">
                    <Button onClick={onClose}>{trans('Button')}</Button>
                </Inline>
            </Stack>
        </DialogModal>
    );
};

export default WaitingForLoginModal;
